import type { DispatchProgress } from '../lib/dispatchProgress'

// One badge for "how much of this row has gone out", used by Inbound and the Notes page.
export default function DispatchStatusBadge({ progress }: { progress: DispatchProgress }) {
  const { state, total, breakdown, completed, planned, drafted, noted } = progress
  const detail = breakdown.map(b => `Note #${b.serial}: ${b.nop} ctns`).join(' · ')
    + ` (Completed ${completed} · Planned ${planned} · Draft ${drafted})`
  const base = 'text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap'
  const frac = (n: number) => n >= total ? '' : ` ${n}/${total}`
  // "Dispatched" only ever means goods really left (COMPLETED notes) -- see dispatchProgress.ts.
  if (state === 'over') {
    return <span className={`${base} bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300`} title={detail}>Over {progress.dispatched}/{total} ⚠️</span>
  }
  if (total > 0 && completed >= total) {
    return <span className={`${base} bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300`} title={detail}>Dispatched ✓</span>
  }
  if (completed > 0) {
    return <span className={`${base} bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-300`} title={detail}>Dispatched {completed}/{total}</span>
  }
  if (planned > 0) {
    return <span className={`${base} bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300`} title={detail}>Planned{frac(planned)}</span>
  }
  if (noted > 0) {
    return <span className={`${base} bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300`} title={detail}>Note drafted{frac(drafted)}</span>
  }
  return <span className={`${base} bg-gray-100 text-gray-500 dark:bg-gray-700 dark:text-gray-400`} title="No note yet">Not dispatched</span>
}
